import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { PurpleEmail, PurplePhone } from 'Images';

interface IContactDetails {
  contacts: {
    cellPhoneNumber: string | null;
    homePhoneNumber: string | null;
    email: string;
  };
}

export const ContactDetails = ({ contacts }: IContactDetails) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack gap='8px'>
      {isDesktop && (
        <Typography variant='body1'>
          {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.contactDetails}
        </Typography>
      )}
      {contacts.cellPhoneNumber && (
        <Stack direction='row' alignItems='center' gap='8px'>
          <Avatar
            alt=''
            src={PurplePhone}
            sx={{ width: '20px', height: '20px' }}
          />
          <Typography variant='body3'>{contacts.cellPhoneNumber}</Typography>
        </Stack>
      )}
      {contacts.homePhoneNumber && (
        <Stack direction='row' alignItems='center' gap='8px'>
          <Avatar
            alt=''
            src={PurplePhone}
            sx={{ width: '20px', height: '20px' }}
          />
          <Typography variant='body3'>{contacts.homePhoneNumber}</Typography>
        </Stack>
      )}
      {contacts.email && (
        <Stack direction='row' alignItems='center' gap='8px'>
          <Avatar
            alt=''
            src={PurpleEmail}
            sx={{ width: '20px', height: '20px' }}
          />
          <Typography variant='body3'>
            {contacts.email.toLocaleLowerCase()}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
